import { useState, useEffect } from "react";
import Layout from "../core/Layout";
import showToast from "../utils/toast";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { assignRoles, getRoleAndPermissionOptions } from "../actions/assignRolesAction";

const styles = {
	container: {
		padding: "0",
		fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
		maxWidth: "900px",
		margin: "0 auto",
		backgroundColor: "transparent",
		minHeight: "100vh",
	},
	header: {
		background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
		borderRadius: "16px 16px 0 0",
		padding: "32px",
		color: "#fff",
		marginBottom: "0",
		position: "relative",
		overflow: "hidden",
	},
	headerContent: {
		position: "relative",
		zIndex: 2,
	},
	headerBg: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		background: "radial-gradient(circle at 20% 80%, rgba(255,255,255,0.1) 0%, transparent 50%)",
		zIndex: 1,
	},
	title: {
		fontSize: "28px",
		fontWeight: "700",
		margin: "0 0 8px 0",
		display: "flex",
		alignItems: "center",
		gap: "12px",
	},
	subtitle: {
		fontSize: "16px",
		opacity: 0.9,
		fontWeight: "400",
		margin: 0,
	},
	icon: {
		width: "32px",
		height: "32px",
		backgroundColor: "rgba(255,255,255,0.2)",
		borderRadius: "8px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontSize: "16px",
	},
	formContainer: {
		backgroundColor: "#fff",
		padding: "32px",
		borderRadius: "0 0 16px 16px",
		boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
		border: "1px solid #e9ecef",
		borderTop: "none",
	},
	form: {
		display: "flex",
		flexDirection: "column",
		gap: "24px",
		marginBottom: "32px",
	},
	formGroup: {
		display: "flex",
		flexDirection: "column",
		gap: "8px",
	},
	label: {
		fontSize: "14px",
		fontWeight: "600",
		color: "#374151",
		marginBottom: "4px",
	},
	row: {
		display: "grid",
		gridTemplateColumns: "1fr 1fr",
		gap: "20px",
		"@media (max-width: 768px)": {
			gridTemplateColumns: "1fr",
		},
	},
	fullRow: {
		display: "grid",
		gridTemplateColumns: "1fr 1fr",
		gap: "20px",
		"@media (max-width: 768px)": {
			gridTemplateColumns: "1fr",
		},
	},
	inputContainer: {
		position: "relative",
		display: "flex",
		flexDirection: "column",
		gap: "4px",
	},
	input: {
		padding: "14px 16px",
		border: "2px solid #e9ecef",
		borderRadius: "12px",
		fontSize: "16px",
		width: "100%",
		backgroundColor: "#f8f9fa",
		color: "#374151",
		transition: "all 0.2s ease",
		fontFamily: "inherit",
		outline: "none",
		boxSizing: "border-box",
	},
	inputFocus: {
		borderColor: "#667eea",
		backgroundColor: "#fff",
		boxShadow: "0 0 0 3px rgba(102, 126, 234, 0.1)",
	},
	passwordContainer: {
		position: "relative",
	},
	showPasswordBtn: {
		position: "absolute",
		right: "16px",
		top: "50%",
		transform: "translateY(-50%)",
		color: "#667eea",
		fontWeight: "600",
		cursor: "pointer",
		fontSize: "14px",
		padding: "4px 8px",
		borderRadius: "6px",
		transition: "color 0.2s",
		userSelect: "none",
	},
	button: {
		padding: "16px 24px",
		background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
		color: "white",
		border: "none",
		borderRadius: "12px",
		cursor: "pointer",
		fontSize: "16px",
		fontWeight: "600",
		transition: "all 0.2s ease",
		boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
		outline: "none",
		position: "relative",
		overflow: "hidden",
	},
	buttonHover: {
		transform: "translateY(-1px)",
		boxShadow: "0 6px 20px rgba(102, 126, 234, 0.4)",
	},
	buttonDisabled: {
		opacity: 0.7,
		cursor: "not-allowed",
		transform: "none",
		boxShadow: "0 4px 12px rgba(102, 126, 234, 0.2)",
	},
	message: {
		padding: "12px 16px",
		borderRadius: "8px",
		fontSize: "14px",
		fontWeight: "500",
		marginTop: "16px",
	},
	messageSuccess: {
		backgroundColor: "#d1f2eb",
		color: "#0f5132",
		border: "1px solid #a7e0d4",
	},
	messageError: {
		backgroundColor: "#f8d7da",
		color: "#721c24",
		border: "1px solid #f5c6cb",
	},
	assignedRoles: {
		marginTop: "40px",
	},
	sectionTitle: {
		fontSize: "20px",
		fontWeight: "700",
		color: "#374151",
		marginBottom: "20px",
		display: "flex",
		alignItems: "center",
		gap: "8px",
	},
	rolesList: {
		display: "flex",
		flexDirection: "column",
		gap: "12px",
	},
	roleCard: {
		backgroundColor: "#fff",
		border: "2px solid #e9ecef",
		borderRadius: "12px",
		padding: "20px",
		transition: "all 0.2s ease",
		boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
	},
	roleCardHover: {
		borderColor: "#667eea",
		boxShadow: "0 4px 16px rgba(102, 126, 234, 0.1)",
		transform: "translateY(-1px)",
	},
	roleHeader: {
		display: "flex",
		alignItems: "center",
		gap: "12px",
		marginBottom: "12px",
	},
	roleAvatar: {
		width: "40px",
		height: "40px",
		borderRadius: "10px",
		background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: "#fff",
		fontSize: "16px",
		fontWeight: "600",
	},
	roleInfo: {
		flex: 1,
	},
	roleEmail: {
		fontSize: "16px",
		fontWeight: "600",
		color: "#374151",
		margin: "0 0 4px 0",
	},
	roleTitle: {
		fontSize: "14px",
		color: "#6b7280",
		margin: 0,
	},
	permissionsList: {
		display: "flex",
		flexWrap: "wrap",
		gap: "6px",
		marginTop: "12px",
	},
	permissionTag: {
		backgroundColor: "#e0e7ff",
		color: "#3730a3",
		padding: "4px 12px",
		borderRadius: "16px",
		fontSize: "12px",
		fontWeight: "500",
	},
	emptyState: {
		textAlign: "center",
		padding: "40px 20px",
		color: "#6b7280",
		fontSize: "16px",
	},
	emptyStateIcon: {
		fontSize: "48px",
		marginBottom: "16px",
		opacity: 0.5,
	},
};

// Custom Select Styles
const selectStyles = {
	control: (base, state) => ({
		...base,
		backgroundColor: "#f8f9fa",
		border: "2px solid #e9ecef",
		borderRadius: "12px",
		padding: "6px 8px",
		fontSize: "16px",
		minHeight: "52px",
		boxShadow: "none",
		borderColor: state.isFocused ? "#667eea" : "#e9ecef",
		"&:hover": {
			borderColor: state.isFocused ? "#667eea" : "#d1d5db",
		},
	}),
	valueContainer: (base) => ({
		...base,
		padding: "0 8px",
	}),
	placeholder: (base) => ({
		...base,
		color: "#9ca3af",
		fontSize: "16px",
	}),
	singleValue: (base) => ({
		...base,
		color: "#374151",
		fontSize: "16px",
	}),
	multiValue: (base) => ({
		...base,
		backgroundColor: "#667eea",
		borderRadius: "8px",
	}),
	multiValueLabel: (base) => ({
		...base,
		color: "#fff",
		fontSize: "14px",
		fontWeight: "500",
	}),
	multiValueRemove: (base) => ({
		...base,
		color: "#fff",
		"&:hover": {
			backgroundColor: "#5a67d8",
			color: "#fff",
		},
	}),
	option: (base, state) => ({
		...base,
		backgroundColor: state.isSelected 
			? "#667eea" 
			: state.isFocused 
			? "#e0e7ff" 
			: "#fff",
		color: state.isSelected ? "#fff" : "#374151",
		"&:active": {
			backgroundColor: "#667eea",
		},
	}),
	menu: (base) => ({
		...base,
		borderRadius: "12px",
		boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
		border: "1px solid #e9ecef",
	}),
};

const AssignRoles = () => {
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		pass: "",
		role: null,
	});
	const [permissions, setPermissions] = useState([]);
	const [rolesList, setRolesList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [message, setMessage] = useState("");
	const [showPass, setShowPass] = useState(false);
	const [roleOptions, setRoleOptions] = useState([]);
	const [permissionOptions, setPermissionOptions] = useState([]);
	const [focusedInput, setFocusedInput] = useState("");
	const dispatch = useDispatch();

	useEffect(() => {
		// Fetch role and permission options using redux action
		(async () => {
			const data = await dispatch(getRoleAndPermissionOptions());
			
			if (data && data.roles && data.permissions) {
				setRoleOptions([
					{ value: '', label: 'Select Role' },
					...data.roles.map((r) => ({ value: r.label, label: r.label }))
				]);
				setPermissionOptions(
					data.permissions.map((p) => ({ value: p, label: p }))
				);
			} else {
				setRoleOptions([{ value: '', label: 'Select Role' }]);
				setPermissionOptions([]);
			}
		})();
	}, [dispatch]);

	const handleSubmit = () => {
		setMessage("");
		if (!formData.email.trim() || !formData.pass.trim()) {
			setMessage("Email and password required");
			return;
		}
		
		setLoading(true);
		
		dispatch(assignRoles({
			email: formData.email.trim(),
			pass: formData.pass.trim(),
			perm: permissions.map((p) => p.value),
			role: formData.role ? formData.role.value : '',
		})).then((action) => {
			setLoading(false);
			console.log(action.message);
			if (action && action.message) {
				setRolesList([...rolesList, { ...formData, permissions }]);
				setFormData({ email: "", pass: "", role: roleOptions[0] });
				setPermissions([]);
				setMessage("Role assigned and email sent!");
			} else {
				setMessage((action && action.payload)||"Error Assigning Roles.");
			}
		});
	};

	const getInitials = (email) => {
		return email.substring(0, 2).toUpperCase();
	};

	return (
		<Layout title={"Assign Roles"}>
			<div style={styles.container}>
				<div style={styles.header}>
					<div style={styles.headerBg}></div>
					<div style={styles.headerContent}>
						<h1 style={styles.title}>
							<div style={styles.icon}>👥</div>
							Assign Roles
						</h1>
					</div>
				</div>

				<div style={styles.formContainer}>
					<div style={styles.form}>
						<div style={styles.row}>
							<div style={styles.inputContainer}>
								<label style={styles.label}>Email Address</label>
								<input
									style={{
										...styles.input,
										...(focusedInput === 'email' ? styles.inputFocus : {})
									}}
									type="email"
									name="email"
									placeholder="Enter user email"
									value={formData.email}
									onFocus={() => setFocusedInput('email')}
									onBlur={() => setFocusedInput('')}
									onChange={(e) => setFormData((f) => ({ ...f, email: e.target.value }))}
								/>
							</div>
							<div style={styles.inputContainer}>
								<label style={styles.label}>Password</label>
								<div style={styles.passwordContainer}>
									<input
										style={{
											...styles.input,
											...(focusedInput === 'password' ? styles.inputFocus : {}),
											paddingRight: "60px"
										}}
										type={showPass ? "text" : "password"}
										name="password"
										placeholder="Enter password"
										value={formData.pass}
										onFocus={() => setFocusedInput('password')}
										onBlur={() => setFocusedInput('')}
										onChange={(e) => setFormData((f) => ({ ...f, pass: e.target.value }))}
									/>
									<span
										onClick={() => setShowPass((v) => !v)}
										style={styles.showPasswordBtn}
									>
										{showPass ? "Hide" : "Show"}
									</span>
								</div>
							</div>
						</div>

						<div style={styles.fullRow}>
							<div style={styles.inputContainer}>
								<label style={styles.label}>User Role</label>
								<Select
									options={roleOptions}
									value={formData.role}
									onChange={(role) => setFormData((f) => ({ ...f, role }))}
									placeholder="Select user role"
									styles={selectStyles}
								/>
							</div>
							<div style={styles.inputContainer}>
								<label style={styles.label}>Permissions</label>
								<Select
									options={permissionOptions}
									isMulti
									value={permissions}
									onChange={setPermissions}
									placeholder="Select permissions"
									styles={selectStyles}
								/>
							</div>
						</div>

						<button
							type="button"
							onClick={handleSubmit}
							disabled={loading}
							style={{
								...styles.button,
								...(loading ? styles.buttonDisabled : {})
							}}
						>
							{loading ? "Assigning..." : "Assign Role"}
						</button>
					</div>

					{message && (
						<div
							style={{
								...styles.message,
								...(message.toLowerCase().includes("error") 
									? styles.messageError 
									: styles.messageSuccess)
							}}
						>
							{message}
						</div>
					)}

					<div style={styles.assignedRoles}>
						<h2 style={styles.sectionTitle}>
							📋 Assigned Roles
						</h2>
						
						{rolesList.length === 0 ? (
							<div style={styles.emptyState}>
								<div style={styles.emptyStateIcon}>👤</div>
								<p>No roles assigned yet.</p>
							</div>
						) : (
							<div style={styles.rolesList}>
								{rolesList.map((item, idx) => (
									<div key={idx} style={styles.roleCard}>
										<div style={styles.roleHeader}>
											<div style={styles.roleAvatar}>
												{getInitials(item.email)}
											</div>
											<div style={styles.roleInfo}>
												<h3 style={styles.roleEmail}>{item.email}</h3>
												<p style={styles.roleTitle}>
													{item.role && item.role.label ? item.role.label : "No Role"}
												</p>
											</div>
										</div>
										{item.permissions && item.permissions.length > 0 && (
											<div style={styles.permissionsList}>
												{item.permissions.map((permission, permIdx) => (
													<span key={permIdx} style={styles.permissionTag}>
														{permission.label}
													</span>
												))}
											</div>
										)}
									</div>
								))}
							</div>
						)}
					</div>
				</div>
			</div>
		</Layout>
	);
};

export default AssignRoles;